"use strict";

module.exports = {
  'layer-hidden': -1,
  'layer-zero': 0,
  'layer-normal': 1,
  'layer-popover': 100,
  'layer-navigation': 200,
  'layer-overlay': 300,
  'layer-alerts': 400
};